import * as React from "react";
import { Box, Typography, Card, Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import InventoryIcon from "@mui/icons-material/Inventory";
import mixpanelAnalytics from "../../mixpanel-analytics/mixpanelAnalytics";
import EVENT from "../../mixpanel-analytics/event";
import useCurrentResourceCentre from "../../hooks/useCurrentResourceCentre";

// @ts-expect-error - css.
import styles from "./Reports.module.css";

const ReportsBillingPackage = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const rc = useCurrentResourceCentre();

  return (
    <Box height="100%">
      <Box sx={{ p: 3 }}>
        <Card
          className={styles.reportCardRoot}
          onClick={() => {
            mixpanelAnalytics.track(EVENT.REPORT_GO_TO_FINANCIAL_CLIENT_LEDGER, {
              rcId: rc.id,
              rcName: rc.name
            });
            return dispatch(push("/reports/financial/billingPackage/package"));
          }}
          data-testmation="packageReport"
        >
          <Grid container>
            <Grid size={8}>
              <Typography fontWeight="700" fontSize="24px">
                Package Report
              </Typography>
            </Grid>
            <Grid size={4}>
              <InventoryIcon className={styles.reportCardChartIcon} />
            </Grid>
          </Grid>
        </Card>
      </Box>
    </Box>
  );
};

export default ReportsBillingPackage;
